export const parseCrunchReadyMessage = (type: string | undefined, title: string, message: string) => {
  if (type !== "CRUNCH" || title !== "CRUNCH READY") return null;

  const match = message.match(/^(?:\*([\s\S]+)\*|([\s\S]+)) (has successfully processed and is ready to review\.)$/);
  if (!match) return null;

  return { fileName: match[1] ?? match[2], status: match[3] };
};
